export const IncorrectPaymentCommand = {
  changePayer: 'chagePayer',
  payInvoice: 'payInvoice',
  customerBalance: 'customerBalance',
  voidPayment: 'voidPayment',
  voidIncorrectPayments: 'voidIncorrectPayments',
};
